<template>
  <div class="min-h-[60vh] flex items-center justify-center px-6">
    <div class="max-w-2xl w-full text-center">
      <h1 class="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Legacy Snapshot has retired</h1>
      <p class="text-base md:text-lg text-gray-600 mb-6">
        Snapshots from ceremony videos are no longer available to purchase.
        If you need help with a previous order, please contact us with your order number.
      </p>
      <a
        href="mailto:clips@mygraduationfilm.com"
        class="inline-block px-4 py-3 text-blue-700 underline rounded focus:outline-none focus:ring-2 focus:ring-blue-700 focus:ring-offset-2"
      >Contact support</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "LegacySnapshotRetired",
};
</script>
